import styled from 'styled-components';

import Button from 'components/common/Button';
import DateRange from 'components/common/DatePicker/DateRange';

export const ButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  padding-top: 1.5rem;
  width: 100%;
`;

export const StyledButton = styled(Button)`
  width: 20.75rem;
`;

export const StyledDateRange = styled(DateRange)`
  margin-top: 1rem;
`;
